import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const incidentImporterSelectors = importerSelectors('incident.importer');

export default incidentImporterSelectors;
